import React, { ReactNode } from 'react';
import { Button, ButtonColor, ButtonSize, isReactNative, Text, usePopupManager } from 'ui-builder';
import { Popup } from '../Popup';
import styles from '../ConfirmDeletePopup/ConfirmPopup.module.scss';

export interface ConfirmPositiveActionPopupProps {
  title: string
  message: ReactNode,
  buttonText?: string,
  submitFormFunc: () => Promise<void>,
  closeOnSubmit?: boolean
}

export function ConfirmPositiveActionPopup(props: ConfirmPositiveActionPopupProps) {
  const popupManager = usePopupManager();

  const submitFunc = async () => {
    await props.submitFormFunc();

    if (props.closeOnSubmit === undefined || props.closeOnSubmit) {
      popupManager.closePopup();
    }
  };

  return (
    <Popup
      title={props.title}
      content={
        <Text
          className={styles.message}
        >
          {props.message}
        </Text>
      }
      buttons={(
        <Button
          key="confirm"
          text={props.buttonText || 'Confirm'}
          onClick={submitFunc}
          color={ButtonColor.GREEN}
          testId="confirm-button"
          size={isReactNative() ? ButtonSize.MEDIUM : ButtonSize.BIG}
        />
      )}
    />
  );
}
